import React from "react";
import ReactDOM from "react-dom";
// import "./styles/index_2.css";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import { Provider } from "react-redux";
//active directory authentication
import { msalConfig } from "./config/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

// Redirect all traffic to staging domain
if (window.location.hostname !== 'sd-st.bkvcorp.com') {
  // Show redirect page matching redirect.html styling
  document.addEventListener('DOMContentLoaded', () => {
    // Clear the page
    document.body.innerHTML = '';

    // Set body styles
    document.body.style.cssText = `
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    `;

    // Create container
    const container = document.createElement('div');
    container.style.cssText = `
      text-align: center;
      background: white;
      padding: 40px;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      max-width: 500px;
    `;

    // Logo
    const logo = document.createElement('img');
    logo.src = '/bkv_logo.png';
    logo.alt = 'BKV Logo';
    logo.style.cssText = 'max-width: 150px; height: auto; margin-bottom: 20px;';
    container.appendChild(logo);

    // Heading
    const heading = document.createElement('h1');
    heading.textContent = 'Application Deactivated';
    heading.style.cssText = 'color: #333; margin: 0 0 10px 0;';
    container.appendChild(heading);

    // Message 1
    const p1 = document.createElement('p');
    p1.textContent = 'This application has been retired.';
    p1.style.cssText = 'color: #666; margin: 10px 0; font-size: 16px;';
    container.appendChild(p1);

    // Message 2
    const p2 = document.createElement('p');
    p2.textContent = 'Redirecting to the new location...';
    p2.style.cssText = 'color: #666; margin: 10px 0; font-size: 16px;';
    container.appendChild(p2);

    // Spinner
    const spinner = document.createElement('div');
    spinner.textContent = '⏳';
    spinner.style.cssText = 'margin: 20px 0; font-size: 32px;';
    container.appendChild(spinner);

    // Manual redirect link
    const link = document.createElement('p');
    const a = document.createElement('a');
    a.href = 'https://sd-st.bkvcorp.com/';
    a.textContent = 'Click here if you are not redirected automatically';
    a.style.cssText = `
      display: inline-block;
      margin-top: 20px;
      padding: 10px 20px;
      background: #667eea;
      color: white;
      text-decoration: none;
      border-radius: 4px;
      transition: background 0.3s;
    `;
    a.onmouseover = () => a.style.background = '#764ba2';
    a.onmouseout = () => a.style.background = '#667eea';
    link.appendChild(a);
    container.appendChild(link);

    document.body.appendChild(container);

    // Clear service workers and cache
    async function clearServiceWorkers() {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
          console.log('Service worker unregistered');
        }
        const cacheNames = await caches.keys();
        for (let cacheName of cacheNames) {
          await caches.delete(cacheName);
          console.log(`Cache '${cacheName}' cleared`);
        }
      } catch (error) {
        console.log('Error clearing service workers/cache:', error);
      }
    }

    if ('serviceWorker' in navigator || 'caches' in window) {
      clearServiceWorkers();
    }

    // Redirect after 3 seconds
    setTimeout(() => {
      window.location.replace('https://sd-st.bkvcorp.com');
    }, 3000);
  });
}


// import { createStore, applyMiddleware } from "redux";
// import rootReducer from "./applications/single_well_surveillance/store/reducers/rootReducer";
// import thunk from "redux-thunk";
// // const store = createStore(rootReducer);
// const store = createStore(rootReducer, applyMiddleware(thunk));

// //used for react-msal-redux
// import { configureStore } from "./store/store_config";
// const initialState = {};
// const store = configureStore({
//   reducer: rootReducer,
//   preloadedState,
// })

// active directory authentication
export const msalInstance = new PublicClientApplication(msalConfig);




// // Catch errors since some browsers throw when using the new `type` option.
// // https://bugs.webkit.org/show_bug.cgi?id=209216
// try {
//   // Create the performance observer.
//   const po = new PerformanceObserver((list) => {
//     for (const entry of list.getEntries()) {
//       console.log(entry);
//     }
//   });
//   // Start listening for `navigation` entries to be dispatched.
//   po.observe({type: 'resource', buffered: true});
// } catch (e) {
//   // Do nothing if the browser doesn't support this API.
// }

ReactDOM.render(
    // <React.StrictMode>
    // <Provider store={store}>
        <App msalInstance={msalInstance} />,
    // </Provider>,
    //</React.StrictMode>
    document.getElementById("root")
);

// Unregister any existing service worker for all users
serviceWorkerRegistration.unregister();
